import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  JaarrapportageEntity,
  ClientEntity,
  Jaarrekening, Jaarrapportage
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {combineLatest, Subject, takeUntil} from 'rxjs';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import {
  SpecFormattedexplanationpolicyComponent
} from '../spec-formattedexplanationpolicy/spec-formattedexplanationpolicy.component';
import { CommonModule } from '@angular/common';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-grondslagen-winst-en-verliesrekening',
    templateUrl: './grondslagen-winst-en-verliesrekening.component.html',
    imports: [
        SharedUiDetailsModule,
        SharedUiButtonModule,
        SpecFormattedexplanationpolicyComponent,
        ReactiveFormsModule,
        CommonModule,
        SharedUiFormControlsModule,
    ],
    styleUrls: ['./grondslagen-winst-en-verliesrekening.component.scss'],
})
export class GrondslagenWinstEnVerliesrekeningComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  public index = 0;
  public dialogVisible = false;
  public isRechtspersoon = false;
  public clientEntity = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public accountingPrinciplesForDeterminingTheResultFg = {} as FormGroup;
  public revenueRecognitionPolicyFg = {} as FormGroup;
  public grossMarginPolicyFg = {} as FormGroup;
  public netRevenuePolicyFg = {} as FormGroup;
  public revenuesFromSaleOfGoodsPolicyFg = {} as FormGroup;
  public revenuesFromProvidingServicesPolicyFg = {} as FormGroup;
  public changesInventoriesWorkInProgressPolicyFg = {} as FormGroup;
  public projectIncomePolicyFg = {} as FormGroup;
  public capitalisedProductionCostsPolicyFg = {} as FormGroup;
  public privateUseOwnBusinessCurrentPolicyFg = {} as FormGroup;
  public exploitationSubsidiesPolicyFg = {} as FormGroup;
  public operatingIncomeOtherPolicyFg = {} as FormGroup;
  public costsRawMaterialsConsumablesPolicyFg = {} as FormGroup;
  public costsOutsourcedWorkOtherExternalExpensesPolicyFg = {} as FormGroup;
  public employeeBenefitsExpensesPolicyFg = {} as FormGroup;
  public wagesSalariesPolicyFg = {} as FormGroup;
  public pensionCostsPolicyFg = {} as FormGroup;
  public depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg = {} as FormGroup;
  public changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg = {} as FormGroup;
  public changesValueInvestmentPropertiesPolicyFg = {} as FormGroup;
  public impairmentCurrentAssetsPolicyFg = {} as FormGroup;
  public operatingExpensesOtherPolicyFg = {} as FormGroup;
  public operatingExpensesPolicyFg = {} as FormGroup;
  public revaluationReserveReleasePolicyFg = {} as FormGroup;
  public financialIncomeExpensesPolicyFg = {} as FormGroup;
  public incomeTaxExpensePolicyFg = {} as FormGroup;
  public shareInResultsParticipatingInterestsPolicyFg = {} as FormGroup;
  public resultEntityPolicyFg = {} as FormGroup;
  public governmentSubsidiesPolicyFg = {} as FormGroup;

  //t.b.v. zichtbaarheid w-en-v onderdelen
  public heeftNettoOmzet = false;
  public heeftWaardeveranderingenVoorraad = false;
  public heeftGeactiveerdeProductieEigenBedrijf = false;
  public heeftPriveGebruikEigenBedrijf = false;
  public heeftExploitatiesubsidies = false;
  public heeftOverigeBedrijfsopbrengsten = false;
  public heeftKostenGrondEnHulpstoffen = false;
  public heeftKostenUitbesteedWerk  = false;
  public heeftLastenUitHoofdePersoneelsbeloningen = false;
  public heeftAfschrijvingenIvaMva = false;
  public heeftWaardeveranderingenIvaMva = false;
  public heeftWaardeveranderingenVastgoedbeleggingen = false;
  public heeftWaardeverminderingenVlottendeActiva = false;
  public heeftOverigeBedrijfskosten = false;
  public heeftBedrijfslasten = false;
  public heeftVrijvalUitHerwaarderingsreserve = false;
  public heeftFinancieleBatenLasten = false;
  public heeftBelastingen = false;
  public heeftResultaatUitDeelnemingen = false;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Keuze actief"},
    {value: false, label: "Keuze niet actief"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  private destroy$ = new Subject<void>();

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService) {
    this.accountingPrinciplesForDeterminingTheResultFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.revenueRecognitionPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.grossMarginPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.netRevenuePolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.revenuesFromSaleOfGoodsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.revenuesFromProvidingServicesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.changesInventoriesWorkInProgressPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.projectIncomePolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.capitalisedProductionCostsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.privateUseOwnBusinessCurrentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.exploitationSubsidiesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.operatingIncomeOtherPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.costsRawMaterialsConsumablesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.costsOutsourcedWorkOtherExternalExpensesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.employeeBenefitsExpensesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.wagesSalariesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.pensionCostsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.changesValueInvestmentPropertiesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.impairmentCurrentAssetsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.operatingExpensesOtherPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.operatingExpensesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.revaluationReserveReleasePolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.financialIncomeExpensesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.incomeTaxExpensePolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.shareInResultsParticipatingInterestsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.resultEntityPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.governmentSubsidiesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
  }

  ngOnInit(): void {
    this.algDataService.client.subscribe((value) => {
      this.clientEntity = value;
    });
    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    });

    const sources = {
      heeftNettoOmzet: this.jrDataService.heeftNettoOmzet,
      heeftWaardeveranderingenVoorraad: this.jrDataService.heeftWaardeveranderingenVoorraad,
      heeftGeactiveerdeProductieEigenBedrijf: this.jrDataService.heeftGeactiveerdeProductieEigenBedrijf,
      heeftPriveGebruikEigenBedrijf: this.jrDataService.heeftPriveGebruikEigenBedrijf,
      heeftExploitatiesubsidies: this.jrDataService.heeftExploitatiesubsidies,
      heeftOverigeBedrijfsopbrengsten: this.jrDataService.heeftOverigeBedrijfsopbrengsten,
      heeftKostenGrondEnHulpstoffen: this.jrDataService.heeftKostenGrondEnHulpstoffen,
      heeftKostenUitbesteedWerk: this.jrDataService.heeftKostenUitbesteedWerk,
      heeftLastenUitHoofdePersoneelsbeloningen: this.jrDataService.heeftLastenUitHoofdePersoneelsbeloningen,
      heeftAfschrijvingenIvaMva: this.jrDataService.heeftAfschrijvingenIvaMva,
      heeftWaardeveranderingenIvaMva: this.jrDataService.heeftWaardeveranderingenIvaMva,
      heeftWaardeveranderingenVastgoedbeleggingen: this.jrDataService.heeftWaardeveranderingenVastgoedbeleggingen,
      heeftWaardeverminderingenVlottendeActiva: this.jrDataService.heeftWaardeverminderingenVlottendeActiva,
      heeftOverigeBedrijfskosten: this.jrDataService.heeftOverigeBedrijfskosten,
      heeftBedrijfslasten: this.jrDataService.heeftBedrijfslasten,
      heeftVrijvalUitHerwaarderingsreserve: this.jrDataService.heeftVrijvalUitHerwaarderingsreserve,
      heeftFinancieleBatenLasten: this.jrDataService.heeftFinancieleBatenLasten,
      heeftBelastingen: this.jrDataService.heeftBelastingen,
      heeftResultaatUitDeelnemingen: this.jrDataService.heeftResultaatUitDeelnemingen
    } as const;

    combineLatest(sources)
      .subscribe(values => {
        Object.assign(this, values);
      });

    this.jrDataService.jaarrapportageEntity.pipe(takeUntil(this.destroy$)).subscribe((jrEntity) => {
      this.jrEntity = jrEntity;
      this.patchData(jrEntity);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private patchData(value: JaarrapportageEntity) {
    const text = value.rapportage?.jaarrekeningen?.at(0)?.toelichting?.grondslagen?.grondslagenWinstEnVerliesrekening;
    if (text) {
      if (text.accountingPrinciplesForDeterminingTheResult) {
        this.accountingPrinciplesForDeterminingTheResultFg.patchValue(text.accountingPrinciplesForDeterminingTheResult);
      }
      if (text.revenueRecognitionPolicy) {
        this.revenueRecognitionPolicyFg.patchValue(text.revenueRecognitionPolicy);
      }
      if (text.grossMarginPolicy) {
        this.grossMarginPolicyFg.patchValue(text.grossMarginPolicy);
      }
      if (text.netRevenuePolicy) {
        this.netRevenuePolicyFg.patchValue(text.netRevenuePolicy);
      }
      if (text.revenuesFromSaleOfGoodsPolicy) {
        this.revenuesFromSaleOfGoodsPolicyFg.patchValue(text.revenuesFromSaleOfGoodsPolicy);
      }
      if (text.revenuesFromProvidingServicesPolicy) {
        this.revenuesFromProvidingServicesPolicyFg.patchValue(text.revenuesFromProvidingServicesPolicy);
      }
      if (text.changesInventoriesWorkInProgressPolicy) {
        this.changesInventoriesWorkInProgressPolicyFg.patchValue(text.changesInventoriesWorkInProgressPolicy);
      }
      if (text.projectIncomePolicy) {
        this.projectIncomePolicyFg.patchValue(text.projectIncomePolicy);
      }
      if (text.capitalisedProductionCostsPolicy) {
        this.capitalisedProductionCostsPolicyFg.patchValue(text.capitalisedProductionCostsPolicy);
      }
      if (text.privateUseOwnBusinessCurrentPolicy) {
        this.privateUseOwnBusinessCurrentPolicyFg.patchValue(text.privateUseOwnBusinessCurrentPolicy);
      }
      if (text.exploitationSubsidiesPolicy) {
        this.exploitationSubsidiesPolicyFg.patchValue(text.exploitationSubsidiesPolicy);
      }
      if (text.operatingIncomeOtherPolicy) {
        this.operatingIncomeOtherPolicyFg.patchValue(text.operatingIncomeOtherPolicy);
      }
      if (text.costsRawMaterialsConsumablesPolicy) {
        this.costsRawMaterialsConsumablesPolicyFg.patchValue(text.costsRawMaterialsConsumablesPolicy);
      }
      if (text.costsOutsourcedWorkOtherExternalExpensesPolicy) {
        this.costsOutsourcedWorkOtherExternalExpensesPolicyFg.patchValue(text.costsOutsourcedWorkOtherExternalExpensesPolicy);
      }
      if (text.employeeBenefitsExpensesPolicy) {
        this.employeeBenefitsExpensesPolicyFg.patchValue(text.employeeBenefitsExpensesPolicy);
      }
      if (text.wagesSalariesPolicy) {
        this.wagesSalariesPolicyFg.patchValue(text.wagesSalariesPolicy);
      }
      if (text.pensionCostsPolicy) {
        this.pensionCostsPolicyFg.patchValue(text.pensionCostsPolicy);
      }
      if (text.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicy) {
        this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg.patchValue(text.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicy);
      }
      if (text.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicy) {
        this.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg.patchValue(text.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicy);
      }
      if (text.changesValueInvestmentPropertiesPolicy) {
        this.changesValueInvestmentPropertiesPolicyFg.patchValue(text.changesValueInvestmentPropertiesPolicy);
      }
      if (text.impairmentCurrentAssetsPolicy) {
        this.impairmentCurrentAssetsPolicyFg.patchValue(text.impairmentCurrentAssetsPolicy);
      }
      if (text.operatingExpensesOtherPolicy) {
        this.operatingExpensesOtherPolicyFg.patchValue(text.operatingExpensesOtherPolicy);
      }
      if (text.operatingExpensesPolicy) {
        this.operatingExpensesPolicyFg.patchValue(text.operatingExpensesPolicy);
      }
      if (text.revaluationReserveReleasePolicy) {
        this.revaluationReserveReleasePolicyFg.patchValue(text.revaluationReserveReleasePolicy);
      }
      if (text.financialIncomeExpensesPolicy) {
        this.financialIncomeExpensesPolicyFg.patchValue(text.financialIncomeExpensesPolicy);
      }
      if (text.incomeTaxExpensePolicy) {
        this.incomeTaxExpensePolicyFg.patchValue(text.incomeTaxExpensePolicy);
      }
      if (text.shareInResultsParticipatingInterestsPolicy) {
        this.shareInResultsParticipatingInterestsPolicyFg.patchValue(text.shareInResultsParticipatingInterestsPolicy);
      }
      if (text.resultEntityPolicy) {
        this.resultEntityPolicyFg.patchValue(text.resultEntityPolicy);
      }
      if (text.governmentSubsidiesPolicy) {
        this.governmentSubsidiesPolicyFg.patchValue(text.governmentSubsidiesPolicy);
      }
    }
  }

  saveForm(): void {
    this.accountingPrinciplesForDeterminingTheResultFg.updateValueAndValidity({ emitEvent: false });
    this.revenueRecognitionPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.grossMarginPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.netRevenuePolicyFg.updateValueAndValidity({ emitEvent: false });
    this.revenuesFromSaleOfGoodsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.revenuesFromProvidingServicesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.changesInventoriesWorkInProgressPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.projectIncomePolicyFg.updateValueAndValidity({ emitEvent: false });
    this.capitalisedProductionCostsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.privateUseOwnBusinessCurrentPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.exploitationSubsidiesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.operatingIncomeOtherPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.costsRawMaterialsConsumablesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.costsOutsourcedWorkOtherExternalExpensesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.employeeBenefitsExpensesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.wagesSalariesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.pensionCostsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.changesValueInvestmentPropertiesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.impairmentCurrentAssetsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.operatingExpensesOtherPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.operatingExpensesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.revaluationReserveReleasePolicyFg.updateValueAndValidity({ emitEvent: false });
    this.financialIncomeExpensesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.incomeTaxExpensePolicyFg.updateValueAndValidity({ emitEvent: false });
    this.shareInResultsParticipatingInterestsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.resultEntityPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.governmentSubsidiesPolicyFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        toelichting: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting,
          grondslagen: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.grondslagen,
            grondslagenWinstEnVerliesrekening: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.grondslagen?.grondslagenWinstEnVerliesrekening,
              accountingPrinciplesForDeterminingTheResult: this.accountingPrinciplesForDeterminingTheResultFg.value,
              revenueRecognitionPolicy: this.revenueRecognitionPolicyFg.value,
              grossMarginPolicy: this.grossMarginPolicyFg.value,
              netRevenuePolicy: this.netRevenuePolicyFg.value,
              revenuesFromSaleOfGoodsPolicy: this.revenuesFromSaleOfGoodsPolicyFg.value,
              revenuesFromProvidingServicesPolicy: this.revenuesFromProvidingServicesPolicyFg.value,
              changesInventoriesWorkInProgressPolicy: this.changesInventoriesWorkInProgressPolicyFg.value,
              projectIncomePolicy: this.projectIncomePolicyFg.value,
              capitalisedProductionCostsPolicy: this.capitalisedProductionCostsPolicyFg.value,
              privateUseOwnBusinessCurrentPolicy: this.privateUseOwnBusinessCurrentPolicyFg.value,
              exploitationSubsidiesPolicy: this.exploitationSubsidiesPolicyFg.value,
              operatingIncomeOtherPolicy: this.operatingIncomeOtherPolicyFg.value,
              costsRawMaterialsConsumablesPolicy: this.costsRawMaterialsConsumablesPolicyFg.value,
              costsOutsourcedWorkOtherExternalExpensesPolicy: this.costsOutsourcedWorkOtherExternalExpensesPolicyFg.value,
              employeeBenefitsExpensesPolicy: this.employeeBenefitsExpensesPolicyFg.value,
              wagesSalariesPolicy: this.wagesSalariesPolicyFg.value,
              pensionCostsPolicy: this.pensionCostsPolicyFg.value,
              depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicy: this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg.value,
              changesInValueIntangibleAssetsPropertyPlantEquipmentPolicy: this.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg.value,
              changesValueInvestmentPropertiesPolicy: this.changesValueInvestmentPropertiesPolicyFg.value,
              impairmentCurrentAssetsPolicy: this.impairmentCurrentAssetsPolicyFg.value,
              operatingExpensesOtherPolicy: this.operatingExpensesOtherPolicyFg.value,
              operatingExpensesPolicy: this.operatingExpensesPolicyFg.value,
              revaluationReserveReleasePolicy: this.revaluationReserveReleasePolicyFg.value,
              financialIncomeExpensesPolicy: this.financialIncomeExpensesPolicyFg.value,
              incomeTaxExpensePolicy: this.incomeTaxExpensePolicyFg.value,
              shareInResultsParticipatingInterestsPolicy: this.shareInResultsParticipatingInterestsPolicyFg.value,
              resultEntityPolicy: this.resultEntityPolicyFg.value,
              governmentSubsidiesPolicy: this.governmentSubsidiesPolicyFg.value,
            },
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
  }
}
